export default __webpack_public_path__ + "static/media/icon-loading.f6bbfe0d.gif";